import React from "react";
import "./ListPagination.scss";

const PAGE_WINDOW = 5;

export const getPageWindow = (totalPages, activePageIndex) => {
  if (totalPages <= PAGE_WINDOW) {
    return { start: 0, end: totalPages };
  }

  const start = Math.min(
    Math.max(0, activePageIndex - 2),
    totalPages - PAGE_WINDOW,
  );
  return { start, end: start + PAGE_WINDOW };
};

const activateOnKeyDown = (event, action) => {
  if (event.key === "Enter" || event.key === " ") {
    event.preventDefault();
    action();
  }
};

const clickableControlProps = (onActivate) => ({
  role: "button",
  tabIndex: 0,
  onClick: onActivate,
  onKeyDown: (event) => activateOnKeyDown(event, onActivate),
});

const ListPagination = ({
  className = "",
  showPagination,
  toShow,
  toShowFun,
  cFrom,
  cTo,
  pCounter,
  showPaggination,
  downPaggination,
  UpPaggination,
}) => {
  const totalPages = pCounter.length;
  const { start: pageWindowStart, end: pageWindowEnd } = getPageWindow(
    totalPages,
    cFrom,
  );

  return (
    <div className={`list-pagination pagination ${className}`.trim()}>
      <ul className="list-pagination__sizes">
        <li
          {...clickableControlProps(() => toShowFun(25))}
          className={toShow === 25 ? "active" : null}
          aria-current={toShow === 25 ? "true" : undefined}
        >
          25
        </li>
        <li
          {...clickableControlProps(() => toShowFun(50))}
          className={toShow === 50 ? "active" : null}
          aria-current={toShow === 50 ? "true" : undefined}
        >
          50
        </li>
        <li
          {...clickableControlProps(() => toShowFun(100))}
          className={toShow === 100 ? "active" : null}
          aria-current={toShow === 100 ? "true" : undefined}
        >
          100
        </li>
      </ul>
      {showPagination ? (
        <ul className="list-pagination__pages">
          {cFrom > 0 ? (
            <li
              {...clickableControlProps(downPaggination)}
              aria-label="עמוד קודם"
            >
              <span>{"<"}</span>
            </li>
          ) : null}
          {totalPages
            ? pCounter.map((element, index) =>
                index >= pageWindowStart && index < pageWindowEnd ? (
                  <li
                    key={index}
                    {...(cFrom !== index
                      ? clickableControlProps(() => showPaggination(element))
                      : { "aria-current": "page" })}
                    className={cFrom === index ? "active" : null}
                  >
                    <span>{element + 1}</span>
                  </li>
                ) : null,
              )
            : null}
          {cFrom < totalPages - 1 ? (
            <li {...clickableControlProps(UpPaggination)} aria-label="עמוד הבא">
              <span>{">"}</span>
            </li>
          ) : null}
        </ul>
      ) : null}
    </div>
  );
};

export default ListPagination;
